<template>
  <div>
    <div class="bg-white rounded-xl max-h-screen p-7 container desktop">
      <div>
        <img src="/i-SET-only.png" alt="" />
      </div>
      <p class="mt-6 mb-3 font-medium" style="color: #a6aeb3">Monitoramento</p>
      <div
        class="group py-3 cursor-pointer flex justify-start items-center g-5"
        :class="classes('home', 'span')"
        @click="activate('home')"
      >
        <icon name="home" class="w-6 h-6 mr-4 ico" :class="classes('home', 'icon')" />
        <div :class="classes('home', 'text')" class="font-medium">Início</div>
      </div>

      <div
        v-for="menu in menus"
        :key="menu.icon"
        class="i-menu flex justify-start items-center g-5 py-3"
        :class="{ 'mt-4': menu.icon === 'home' }"
        @click="activate(menu.icon)"
      >
        <img
          :src="`i-${menu.icon}.${menu.ext}`"
          class="w-6 h-6 mr-4"
          v-if="menu.icon == 'SET-mini'"
        />
        <img :src="`i-gray-${menu.icon}.${menu.ext}`" class="w-6 h-6 mr-4" v-else />
        <div class="text-center">
          <p class="link">{{ menu.label }}</p>
        </div>
      </div>
    </div>
    <div class="mobile">
      <div class="w-10 h-10 relative" @click="showMenu = !showMenu">
        <svg
          class="fill-gray-500 w-full h-full"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
        </svg>

        <div class="menu-mobile" v-if="showMenu">
          <div
            v-for="menu in menus"
            :key="menu.icon"
            class="i-menu flex justify-start items-center g-5 py-3"
            :class="{ 'mt-4': menu.icon === 'home' }"
            @click="activate(menu.icon)"
          >
            <img
              :src="`i-${menu.icon}.${menu.ext}`"
              class="w-5 h-5 mr-4"
              v-if="menu.icon == 'SET-mini'"
            />
            <img :src="`i-gray-${menu.icon}.${menu.ext}`" class="w-5 h-5 mr-4" v-else />
            <div class="text-center">
              <p class="link link_mobile">{{ menu.label }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'

export default {
  components: {
    Icon,
  },
  data() {
    return {
      active: (() => {
        const params = new Proxy(new URLSearchParams(window.location.search), {
          get: (searchParams, prop) => searchParams.get(prop),
        })

        return params.menu ?? 'home'
      })(),
      get menus() {
        return [
          { icon: 'flag', label: 'Território', ext: 'png' },
          { icon: 'bus', label: 'Transporte', ext: 'png' },
          { icon: 'briefcase', label: 'Emprego', ext: 'png' },
          { icon: 'invoice', label: 'Financeiro', ext: 'png' },
          { icon: 'departure', label: 'Turismo', ext: 'png' },
          { icon: 'security', label: 'Segurança Pública', ext: 'png' },
          { icon: 'SET-mini', label: 'RADAR SET - DTI', ext: 'jpg' },
          { icon: 'chart', label: 'Inteligência de Mercado', ext: 'png' },
        ]
      },
      showMenu: false,
    }
  },
  updated() {
    this.activate(this.active)
  },
  methods: {
    classes(icon, el) {
      const classes = {}

      switch (el) {
        case 'span':
          // classes[`hover:text-indicator-${icon}-d`] = true
          // classes[`text-indicator-${icon}-d`] = this.active === icon
          break
        case 'icon':
          if (this.active === icon) {
            // classes[`fill-indicator-${icon}-d`] = true
          } else {
            // classes[`fill-indicator-${icon}`] = true
            // classes[`group-hover:fill-indicator-${icon}-d`] = true
          }
          break
        case 'text':
          if (this.active === icon) {
            // classes[`text-indicator-${icon}-d`] = true
            classes['text-indigo'] = true
          } else {
            // classes[`text-indicator-${icon}`] = true
            // classes[`group-hover:text-indicator-${icon}-d`] = true
            // classes['text-white'] = true
            classes['group-hover:text-indigo'] = true
          }
          break
      }

      return classes
    },
    activate(menu) {
      this.active = menu

      document.getElementById('menu_active').value = menu

      this.$parent.$children.forEach((child) => {
        if (child.$el?.id == 'indicators') {
          const $indicators = child
          const $refs = $indicators?.$refs
          const $ref = $refs[menu]

          Object.keys($indicators?.indicators).forEach((group) => {
            $indicators?.indicators[group].forEach((row) =>
              row.forEach((indicator) => {
                const checkbox = document.getElementById(`i-${indicator.id}`)

                checkbox.parentElement.parentElement.classList.add('hidden')

                if (menu === 'home') {
                  checkbox.parentElement.parentElement.classList.remove('hidden')

                  return
                }

                $ref?.indicators?.forEach((refIndicator) => {
                  if (refIndicator.id == indicator.id) {
                    checkbox.parentElement.parentElement.classList.remove('hidden')
                  }
                })
              }),
            )
          })

          if ($refs) {
            for (const component in $refs) {
              const $component = $refs[component]

              $component?.$el?.classList.add('hidden')

              if ($component == $ref || menu === 'home' || component === 'home') {
                $component?.$el?.classList.remove('hidden')
              }
            }
          }

          ;[
            Array.from(document.getElementsByClassName('form-control')),
            Array.from(document.getElementsByClassName('multiselect')),
          ].forEach((list) =>
            list.forEach((control) => {
              if (
                control.hasAttribute('menu-protected') &&
                control.getAttribute('menu-protected') === String(true)
              ) {
                return
              }

              if (this.active == 'home') {
                control.parentElement.classList.remove('hidden')

                return
              }

              let menu = control.getAttribute('menu')

              if (menu === '*') {
                return
              }

              menu = menu.split(',')

              control.parentElement.classList.add('hidden')

              if (menu.includes(this.active)) {
                control.parentElement.classList.remove('hidden')
              }
            }),
          )

          const hiddens = [
            Array.from(document.getElementsByClassName('t-th')),
            Array.from(document.getElementsByClassName('t-td')),
            Array.from(document.getElementsByClassName('c-div')),
          ]

          hiddens.forEach((hidden) => {
            hidden.forEach((result) => {
              result.classList.add('hidden')

              if (this.active === 'home') {
                result.classList.remove('hidden')
              }
            })
          })

          if (this.active !== 'home') {
            const unhiddens = [
              Array.from(document.getElementsByClassName(`t-${menu}`)),
              Array.from(document.getElementsByClassName(`c-${menu}`)),
            ]

            unhiddens.forEach((unhidden) => {
              unhidden.forEach((result) => {
                result.classList.remove('hidden')
              })
            })
          }

          const tableSet = [
            ...new Set(
              Array.from(document.getElementsByClassName('t-td')).map((td) =>
                td.classList.contains('hidden'),
              ),
            ),
          ]

          const tableFooter = document.getElementById('i-table-foot')

          tableFooter?.classList.remove('hidden')

          if (tableSet.includes(true) && !tableSet.includes(false)) {
            tableFooter?.classList.add('hidden')
          }

          const fieldsets = Array.from(document.getElementsByClassName('fieldset'))

          fieldsets.forEach((fieldset) => {
            fieldset.classList.add('hidden')

            const visible = Array.from(fieldset.querySelectorAll('div.mx-3.mb-3')).filter(
              (indicator) => !indicator.classList.contains('hidden'),
            )

            if (visible.length > 0) {
              fieldset.classList.remove('hidden')
            }
          })
        }
      })
    },
    reactivate() {
      this.activate(this.active)
    },
  },
}
</script>

<style scoped>
.container {
  height: 98vh;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
}

.ico {
  fill: #545f65;
}

.link {
  cursor: pointer;
  font-weight: 500;
}

.link:hover {
  color: #00a39a;
}

.mobile {
  display: none;
}

.menu-mobile {
  position: absolute;
  top: 50px;
  background-color: #fff;
  width: 240px;
  height: max-content;
  z-index: 10;
  border-radius: 12px;
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.08);
  user-select: none;
  padding: 12px;
}

.link_mobile {
  font-size: 14px;
}

.unselectable {
  user-select: none;
}

@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }

  .mobile {
    display: block;
  }
}
</style>
